import { render, staticRenderFns } from "./PhoRadio.vue?vue&type=template&id=987c9ab4&lang=pug"
import script from "./PhoRadio.vue?vue&type=script&lang=js"
export * from "./PhoRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports